import { render, staticRenderFns } from "./SettingsCampaign.vue?vue&type=template&id=332bbb48&scoped=true&"
import script from "./SettingsCampaign.vue?vue&type=script&lang=js&"
export * from "./SettingsCampaign.vue?vue&type=script&lang=js&"
import style0 from "./SettingsCampaign.vue?vue&type=style&index=0&id=332bbb48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332bbb48",
  null
  
)

export default component.exports